export default __webpack_public_path__ + "static/CandiceAllphin-73e765f44ef50ee3f50386f1bcbdf369.jpg";